import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_back",
  "use": "svg_back-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"svg_back\"><path d=\"M18 8a.75.75 0 0 1-.75.75H2.56l5.47 5.47a.75.75 0 0 1-1.061 1.06L.219 8.53a.75.75 0 0 1 0-1.06L6.969.72A.75.75 0 1 1 8.03 1.78L2.56 7.25h14.69A.75.75 0 0 1 18 8Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol